"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../../utils/getPrefixCls");
var _rcTextarea = _interopRequireDefault(require("rc-textarea"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var TextArea = function TextArea(props) {
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('probing-form-input');
  var readOnly = props.readOnly,
    placeholder = props.placeholder,
    value = props.value,
    onChange = props.onChange,
    maxLimit = props.maxLimit,
    minLimit = props.minLimit,
    minLimitPrompt = props.minLimitPrompt,
    minLimitPromptWhenError = props.minLimitPromptWhenError;
  var onInputChange = function onInputChange(e) {
    var _e$target$value, _e$target$value$slice;
    onChange === null || onChange === void 0 ? void 0 : onChange((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : (_e$target$value$slice = _e$target$value.slice) === null || _e$target$value$slice === void 0 ? void 0 : _e$target$value$slice.call(_e$target$value, 0, maxLimit));
  };
  var hasError = (value === null || value === void 0 ? void 0 : value.length) !== undefined && (value === null || value === void 0 ? void 0 : value.length) < minLimit;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, readOnly ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, " ").concat(PREFIX, "__disabled")
  }, props.value) : /*#__PURE__*/_react.default.createElement(_rcTextarea.default, {
    autoSize: true,
    className: PREFIX,
    placeholder: placeholder,
    value: value,
    onChange: onInputChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("".concat(PREFIX, "__limit"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "__error"), hasError))
  }, hasError ? minLimitPromptWhenError : minLimitPrompt));
};
exports.TextArea = TextArea;